import { Injectable, inject } from '@angular/core';
import { APP_CONFIG, AppConfig } from './appConfig.provider';
import { hasPlatformFeature, PlatformFeature } from './platform-features';

@Injectable({ providedIn: 'root' })
export class PlatformFeatureService {
  private readonly appConfig = inject<AppConfig>(APP_CONFIG);

  public isEnabled(feature: PlatformFeature): boolean {
    return hasPlatformFeature(this.appConfig.enabledPlatformFeatures, feature);
  }

  public areEnabled(features?: readonly PlatformFeature[] | null): boolean {
    return features?.every((feature) => this.isEnabled(feature)) ?? true;
  }

  public isVisible(feature: PlatformFeature, runtimeAllowed = true): boolean {
    return runtimeAllowed && this.isEnabled(feature);
  }
}
